module.exports = new __parcel__URL__("73084_sq.63c5161d.jpg").toString();